import { ColumnDef } from "@tanstack/react-table"

export type Expense = {
  id: number
  amount: string
  title: string
}

export const columns: ColumnDef<Expense>[] = [
  // {
  //   header: "User",
  //   cell: ({ row }) => <LetterAvatar name={row.original.name} />,
  // },
  {
    header: "Amount",
    accessorKey: "amount",
  },
  {
    header: "Title",
    accessorKey: "title",
  },
  {
    header: "Date",
    accessorKey: "date",
  },
]
